import { createSafeAnalyticsClient } from '../../../lib/analytics';
import { ExercisesAnalytics } from './types';

export const exercisesAnalytics = createSafeAnalyticsClient<
  ExercisesAnalytics.EventName,
  ExercisesAnalytics.EventNameToEventBody
>();
